<template>
  <div>
    <b-card title="Documentation - some important service documents">
      <span class="d-block my-4" />
      <b-row
        v-for="doc in docs"
        :key="doc.id"
        class="my-2"
      >
        <b-col
          cols="12"
          md="3"
        >
          <h5>{{ doc.title }}</h5>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          {{ doc.description }}
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="text-center"
        >
          <a
            :href="doc.link"
          >
            <b-img
              height="40"
              :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
              style="width: auto;"
            />
          </a>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      docs: [],
    }
  },
  mounted() {
    this.loadDocs()
  },
  methods: {
    loadDocs() {
      this.docs = [
        {
          id: 1,
          title: 'Scope of Service',
          description: 'A full description of the scope of the structured products research service offered by FVC for UK IFAs and other financial professionals',
          link: 'https://www.structurededge.co.uk/downloadhelppdf.cfm?id=1',
        },
        {
          id: 2,
          title: 'Research Methodology',
          description: 'Detailed methodology and explanations of the analysis presented in each research report',
          link: 'https://www.structurededge.co.uk/downloadhelppdf.cfm?id=2',
        },
        {
          id: 3,
          title: 'Due Diligence Pack',
          description: 'A comprehensive pack particularly aimed at compliance officers or others in an IFA firm who wish to obtain some background information about FVC and its experience in structured products',
          link: 'https://www.structurededge.co.uk/downloadhelppdf.cfm?id=4',
        },
      ]
    },
  },
}
</script>

<style>

</style>
